import cx from "classnames";
import { ReactNode } from "react";
import { faCheck } from "@fortawesome/pro-solid-svg-icons";

import Icon from "common/components/Icon";

import styles from "../../styles/Checkbox.module.less";

type CheckboxProps = {
  value: boolean;
  onChange: (value: boolean) => void;
  labelContent?: ReactNode;
  disabled?: boolean;
  styles?: {
    container?: string;
    label?: string;
  };
};

const Checkbox = ({
  value,
  onChange,
  labelContent,
  disabled = false,
  styles: propStyles = {},
}: CheckboxProps) => {
  return (
    <label className={cx(styles.container, disabled && styles.disabled, propStyles.container)}>
      <span className={styles.box}>
        <input
          className={styles.checkbox}
          type="checkbox"
          checked={value}
          disabled={disabled}
          onChange={(event) => onChange(event.target.checked)}
        />
        {value && <Icon className={styles.icon} fixedWidth={true} icon={faCheck} />}
      </span>
      <span className={cx(styles.label, propStyles.label)}>{labelContent}</span>
    </label>
  );
};

export default Checkbox;
